


















import CopyStakeStreamerFraudReportsTable from '@/views/CopyStake/CopyStakeStreamerFraudReports/CopyStakeStreamerFraudReportsTable.vue';
import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';

export default {
  name: 'CopyStakeStreamerFraudReportsView',
  mixins: [FeatureFlagRedirectMixin],
  components: {
    CopyStakeStreamerFraudReportsTable
  },
  data(): Record<string, unknown> {
    return {
      unreadReportsCount: 0
    };
  }
};
